import { Store } from '@ngrx/store';
import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { ScheduleEvent, ScheduleProgrammingService } from '../../quickstarts/quickstart-schedule/services/schedule.service';

@Component({
  selector: 'prg-recent',
  templateUrl: './recent.component.html',
  styleUrls: ['./recent.component.less']
})
export class RecentComponent implements OnInit {

  scheduleEvents: Observable<ScheduleEvent[]>;

  constructor(
    private store: Store<any>,
    private schedule: ScheduleProgrammingService
  ) {
    this.scheduleEvents = this.schedule.scheduleEvents;
  }

  ngOnInit() {  }

}



// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/common/recent/recent.component.ts